import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import { Anchor as n, Content as r, Portal as i, Root as a } from "../../node_modules/@radix-ui/react-popover/dist/index.js";
import "react";
import { jsxDEV as o } from "react/jsx-dev-runtime";
//#region lib/components/DatePicker/DateFieldPopover.tsx
var s = "/opt/render/project/src/shared-ui/lib/components/DatePicker/DateFieldPopover.tsx";
function c({ open: c, onOpenChange: l, trigger: u, children: d, contentProps: f, anchorProps: p, portalProps: m }) {
	return /* @__PURE__ */ o(a, {
		open: c,
		onOpenChange: l,
		children: [/* @__PURE__ */ o(n, {
			...p,
			children: u
		}, void 0, !1, {
			fileName: s,
			lineNumber: 32,
			columnNumber: 13
		}, this), /* @__PURE__ */ o(i, {
			...m,
			children: /* @__PURE__ */ o(r, {
				sideOffset: 4,
				...f,
				className: e(t.popoverContent, f?.className),
				children: d
			}, void 0, !1, {
				fileName: s,
				lineNumber: 34,
				columnNumber: 17
			}, this)
		}, void 0, !1, {
			fileName: s,
			lineNumber: 33,
			columnNumber: 13
		}, this)]
	}, void 0, !0, {
		fileName: s,
		lineNumber: 31,
		columnNumber: 9
	}, this);
}
//#endregion
export { c as DateFieldPopover };
